export default __webpack_public_path__ + "static/media/icon-increase.341f2dc0.svg";